import { render } from "./IconNotificationThanks.vue?vue&type=template&id=6ea54be2"
import script from "./IconNotificationThanks.vue?vue&type=script&lang=js"
export * from "./IconNotificationThanks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__